export default __webpack_public_path__ + "static/media/myqr.d7b77c7c.jpeg";